import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route } from '@angular/router';
import { AuthGuard } from '../../auth.guard';
import { SharedModule } from '../../shared/shared.module';

// PHF Administration
import { AdministrationComponent } from './administration/administration.component';
import { UsersComponent } from './administration/security/users/users.component';
import { ProgramComponent } from './administration/program/program.component';
import { PlantComponent } from './administration/plant/plant.component';
import { PressComponent } from './administration/press/press.component';
import { DistributionMethodComponent } from './administration/distribution-method/distribution-method.component';
import { DieFamilyComponent } from './administration/die-family/die-family.component';
import { UploadComponent } from './administration/upload/upload.component';
import { PartTypeComponent } from './administration/part-type/part-type.component';

// PHF
import { PhfComponent } from './phf.component';

// Part List
import { PartListComponent } from './part/part-list/part-list.component';
import { PartComponent } from './part/part.component';
import { PartSearchComponent } from './part/part-list/part-search/part-search.component';
import { CalculationComponent } from './part/part-list/calculation/calculation.component';
import { PartDetailComponent } from './part/part-list/part-detail/part-detail.component';
import { GeneralTabComponent } from './part/part-list/part-detail/general-tab/general-tab.component';
import { DieDetailTabComponent } from './part/part-list/part-detail/die-detail-tab/die-detail-tab.component';
import { PartHandlingTabComponent } from './part/part-list/part-detail/part-handling-tab/part-handling-tab.component';
import { PartLoadingTabComponent } from './part/part-list/part-detail/part-loading-tab/part-loading-tab.component';
import { ContainerTabComponent } from './part/part-list/part-detail/container-tab/container-tab.component';
import { PressTabComponent } from './part/part-list/part-detail/press-tab/press-tab.component';
import { PartDetailHeaderComponent } from './part/part-list/part-detail/part-detail-header/part-detail-header.component';
import { OptimizationResultsComponent } from './part/part-list/optimization-results/optimization-results.component';
import { ToolsetEditWindowComponent } from './part/part-list/part-detail/part-detail-header/toolset-edit-window/toolset-edit-window.component';
import { ApplyReportComponent } from './administration/upload/apply-report/apply-report.component';
import { FileUploadComponent } from './part/part-list/part-detail/file-upload/file-upload.component';

// Parts 

// Services
import {
  ProgramService,
  AllocationService,
  AttachmentService,
  PlantService,
  PressService,
  PartService,
  PartSourceService,
  DistributionCategoryService,
  DistributionMethodService,
  PartHandlingService,
  PartLoadingService,
  ContainerService,
  PHFUserService,
  ContainerTypeService,
  ContainerSourceService,
  SideService,
  DieFamilyService,
  DieService,
  DieSourceService,
  MaterialService,
  MakeBuyService,
  ToolSetService,
  LoadingMethodService,
  OrientationService,
  ContainerStyleService,
  PartTypeService,
  CommonHandlerService

} from './phf.service';
import { UploadService } from './administration/upload/upload-service'
import { PartDetailService } from './part/part-list/part-detail/part-detail.service';
import { PartListService } from './part/part-list/part-list.service';
import { S3Service } from '../../shared/services/s3.service';
import { OrientationCarrierDialog } from './part/part-list/part-detail/part-loading-tab/orientation-carrier/orientation-carrier';
import { OrientationEOLDialog } from './part/part-list/part-detail/part-loading-tab/orientation-eol/orientation-eol';
import { OrientationDieDialog } from './part/part-list/part-detail/part-loading-tab/orientation-die/orientation-die';
import { OrientationContainerDialog } from './part/part-list/part-detail/part-loading-tab/orientation-container/orientation-container';
import { StyleComponent } from './part/part-list/part-detail/container-tab/style-window/style.component';
import { PressLineDetailsComponent } from './part/part-list/part-search/press-line-details/press-line-details.component';
import { SelectProgramComponent } from './administration/upload/select-program/select-program.component';
import { ZoominDialogComponent } from './part/part-list/part-detail/zoomin-dialog/zoomin-dialog.component';

export const phfRoutes: Route = {
  path: 'PHF',
  component: PhfComponent,
  canActivate: [AuthGuard],
  data: { breadcrumb: "PHF" },
  children: [
    {
      path: 'Administration',
      component: AdministrationComponent,
      canActivate: [AuthGuard],
      data: { breadcrumb: "Administration" },
      children: [// Security
        {
          path: 'Users',
          data: { breadcrumb: "Users" },
          component: UsersComponent,
          canActivate: [AuthGuard],
        },
        {
          path: 'Program',
          data: { breadcrumb: "Program" },
          component: ProgramComponent,
          canActivate: [AuthGuard],
        },
        {
          path: 'Plant',
          data: { breadcrumb: "Plant" },
          component: PlantComponent,
          canActivate: [AuthGuard],
        },
        {
          path: 'Press',
          data: { breadcrumb: "Press" },
          component: PressComponent,
          canActivate: [AuthGuard],
        },
        {
          path: 'Distribution-method',
          data: { breadcrumb: "Distribution Method" },
          component: DistributionMethodComponent,
          canActivate: [AuthGuard],
        },
        {
          path: 'Die-Family',
          data: { breadcrumb: "Die Family" },
          component: DieFamilyComponent,
          canActivate: [AuthGuard],
        },
        {
          path: 'Part-Type',
          data: { breadcrumb: "Part Type" },
          component: PartTypeComponent,
          canActivate: [AuthGuard],
        },
        {
          path: 'Upload',
          data: { breadcrumb: "Upload" },
          component: UploadComponent,
          canActivate: [AuthGuard],
        }
      ]
    },
    {
      path: 'Parts',
      data: { breadcrumb: "Parts List" },
      component: PartListComponent,
      canActivate: [AuthGuard],
    }

  ]
}

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
  ],
  declarations: [
    PhfComponent,
    AdministrationComponent,
    PartListComponent,
    PartComponent,
    PressComponent,
    UsersComponent,
    ProgramComponent,
    PlantComponent,
    DistributionMethodComponent,
    DieFamilyComponent,
    PartTypeComponent,
    UploadComponent,
    PartSearchComponent,
    CalculationComponent,
    PartDetailComponent,
    GeneralTabComponent,
    DieDetailTabComponent,
    PartHandlingTabComponent,
    PartLoadingTabComponent,
    ContainerTabComponent,
    PressTabComponent,
    PartDetailHeaderComponent,
    OptimizationResultsComponent,
    FileUploadComponent,
    ToolsetEditWindowComponent,
    OrientationCarrierDialog,
    OrientationEOLDialog,
    OrientationDieDialog,
    OrientationContainerDialog,
    //LoadingMethodDialog,
    ApplyReportComponent,
    StyleComponent,
    PressLineDetailsComponent,
    SelectProgramComponent,
    ZoominDialogComponent,

  ],
  providers: [
    ProgramService,
    AllocationService,
    AttachmentService,
    PlantService,
    PressService,
    PartService,
    PartSourceService,
    DistributionCategoryService,
    DistributionMethodService,
    UploadService,
    DieFamilyService,
    PartHandlingService,
    PartLoadingService,
    PartTypeService,
    ContainerService,
    PHFUserService,
    PartListService,
    ContainerTypeService,
    ContainerSourceService,
    SideService,
    ContainerStyleService,
    DieService,
    DieSourceService,
    PartDetailService,
    MaterialService,
    MakeBuyService,
    ToolSetService,
    OrientationService,
    LoadingMethodService,
    S3Service,
    CommonHandlerService
  ]
})
export class PhfModule { }
